import { render } from "./systemSetting.vue?vue&type=template&id=d48462ec&scoped=true"
import script from "./systemSetting.vue?vue&type=script&lang=js"
export * from "./systemSetting.vue?vue&type=script&lang=js"

import "./systemSetting.vue?vue&type=style&index=0&id=d48462ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d48462ec"]])

export default __exports__